// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GetAccountsApiParameter } from "@insite/client-framework/Services/AccountService";
import { doesNotHaveExpand, get } from "@insite/client-framework/Services/ApiService";
import { AccountCollectionModel, AccountModel } from "@insite/client-framework/Types/ApiModels";

// XNG-Changes: override getAccounts to add "no-store"
const accountsUrl = "/api/v1/accounts";
export async function getAccounts(parameter: GetAccountsApiParameter) {
    const accountCollection = await get<AccountCollectionModel>(accountsUrl, parameter, {}, "no-store");
    accountCollection.accounts?.forEach(o => cleanAccount(o));
    return accountCollection;
}

// XNG-Changes: need to be here, because no export in OOTB files
function cleanAccount(accountModel: AccountModel, parameter?: { expand?: string[]; additionalExpands?: string[] }) {
    accountModel.lastLoginOn = accountModel.lastLoginOn && new Date(accountModel.lastLoginOn);
    if (doesNotHaveExpand(parameter, "roles")) {
        accountModel.availableRoles = null;
    }

    if (doesNotHaveExpand(parameter, "approvers")) {
        accountModel.availableApprovers = null;
    }
}
